/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetToursParams,
  SchemaValidationErrorResponse,
  StandardError,
  Tour,
  TourCreateInput,
  TourJoinRequest,
  TourJoinRequestsList,
  TourUpdateInput,
  ToursList,
  ToursParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Fleet Tour
 */
export const createFleetTour = (
    fleetSlug: MaybeRefOrGetter<string>,
    tourCreateInput: MaybeRefOrGetter<TourCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
tourCreateInput = toValue(tourCreateInput);

      return axiosClient<Tour>(
      {url: `/fleets/${fleetSlug}/tours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tourCreateInput, signal
    },
      );
    }




export const getCreateFleetTourMutationKey = () => ['createFleetTour'] as const;

export const getCreateFleetTourMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetTour>>, TError,CreateFleetTourMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetTour>>, TError,CreateFleetTourMutationVariables, TContext> => {

const mutationKey = getCreateFleetTourMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetTour>>, CreateFleetTourMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetTour(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetTourMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetTour>>>
    export type CreateFleetTourMutationBody = TourCreateInput
    export type CreateFleetTourMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetTourMutationVariables = {fleetSlug: string;data: TourCreateInput}

    /**
 * @summary Create Fleet Tour
 */
export const useCreateFleetTour = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetTour>>, TError,CreateFleetTourMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetTour>>,
        TError,
        CreateFleetTourMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetTourMutationOptions(options), queryClient);
    }
    /**
 * @summary List Fleet Tours
 */
export const fleetTours = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetToursParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<ToursList>(
      {url: `/fleets/${fleetSlug}/tours`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetToursQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetToursParams>,) => {
    return [
    'fleets',fleetSlug,'tours', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetToursQueryOptions = <TData = Awaited<ReturnType<typeof fleetTours>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetToursParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetTours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetToursQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetTours>>> = ({ signal }) => fleetTours(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetTours>>, TError, TData>
}

export type FleetToursQueryResult = NonNullable<Awaited<ReturnType<typeof fleetTours>>>
export type FleetToursQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Fleet Tours
 */

export function useFleetTours<TData = Awaited<ReturnType<typeof fleetTours>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetToursParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetTours>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetToursQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Show Fleet Tour
 */
export const fleetTour = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<Tour>(
      {url: `/fleets/${fleetSlug}/tours/${slug}`, method: 'GET', signal
    },
      );
    }




export const getFleetTourQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'tours',slug
    ] as const;
    }


export const getFleetTourQueryOptions = <TData = Awaited<ReturnType<typeof fleetTour>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetTour>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetTourQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetTour>>> = ({ signal }) => fleetTour(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetTour>>, TError, TData>
}

export type FleetTourQueryResult = NonNullable<Awaited<ReturnType<typeof fleetTour>>>
export type FleetTourQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Fleet Tour
 */

export function useFleetTour<TData = Awaited<ReturnType<typeof fleetTour>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetTour>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetTourQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Tour
 */
export const createTour = (
    tourCreateInput: MaybeRefOrGetter<TourCreateInput>,
 signal?: AbortSignal
) => {
      tourCreateInput = toValue(tourCreateInput);

      return axiosClient<Tour>(
      {url: `/tours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tourCreateInput, signal
    },
      );
    }




export const getCreateTourMutationKey = () => ['createTour'] as const;

export const getCreateTourMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTour>>, TError,CreateTourMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTour>>, TError,CreateTourMutationVariables, TContext> => {

const mutationKey = getCreateTourMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTour>>, CreateTourMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTour(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTourMutationResult = NonNullable<Awaited<ReturnType<typeof createTour>>>
    export type CreateTourMutationBody = TourCreateInput
    export type CreateTourMutationError = ErrorType<ValidationError | StandardError>
    export type CreateTourMutationVariables = {data: TourCreateInput}

    /**
 * @summary Create Tour
 */
export const useCreateTour = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTour>>, TError,CreateTourMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTour>>,
        TError,
        CreateTourMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTourMutationOptions(options), queryClient);
    }
    /**
 * @summary List Tours
 */
export const tours = (
    params?: MaybeRefOrGetter<ToursParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ToursList>(
      {url: `/tours`, method: 'GET',
        params, signal
    },
      );
    }




export const getToursQueryKey = (params?: MaybeRefOrGetter<ToursParams>,) => {
    return [
    'tours', ...(params ? [params] : [])
    ] as const;
    }


export const getToursQueryOptions = <TData = Awaited<ReturnType<typeof tours>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ToursParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getToursQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tours>>> = ({ signal }) => tours(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tours>>, TError, TData>
}

export type ToursQueryResult = NonNullable<Awaited<ReturnType<typeof tours>>>
export type ToursQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Tours
 */

export function useTours<TData = Awaited<ReturnType<typeof tours>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ToursParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tours>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getToursQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Preview a tour behind an invite link
 */
export const findTourByInvite = (
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      token = toValue(token);

      return axiosClient<Tour>(
      {url: `/tours/find-by-invite/${token}`, method: 'GET', signal
    },
      );
    }




export const getFindTourByInviteQueryKey = (token: MaybeRefOrGetter<string>,) => {
    return [
    'tours','find-by-invite',token
    ] as const;
    }


export const getFindTourByInviteQueryOptions = <TData = Awaited<ReturnType<typeof findTourByInvite>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTourByInvite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFindTourByInviteQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTourByInvite>>> = ({ signal }) => findTourByInvite(token, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(token) !== null && toValue(token) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTourByInvite>>, TError, TData>
}

export type FindTourByInviteQueryResult = NonNullable<Awaited<ReturnType<typeof findTourByInvite>>>
export type FindTourByInviteQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Preview a tour behind an invite link
 */

export function useFindTourByInvite<TData = Awaited<ReturnType<typeof findTourByInvite>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTourByInvite>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindTourByInviteQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Join Tour
 */
export const joinTour = (
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      token = toValue(token);

      return axiosClient<Tour>(
      {url: `/tours/join/${token}`, method: 'POST', signal
    },
      );
    }




export const getJoinTourMutationKey = () => ['joinTour'] as const;

export const getJoinTourMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinTour>>, TError,JoinTourMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof joinTour>>, TError,JoinTourMutationVariables, TContext> => {

const mutationKey = getJoinTourMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinTour>>, JoinTourMutationVariables> = (props) => {
          const {token} = props ?? {};

          return  joinTour(token,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinTourMutationResult = NonNullable<Awaited<ReturnType<typeof joinTour>>>

    export type JoinTourMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type JoinTourMutationVariables = {token: string}

    /**
 * @summary Join Tour
 */
export const useJoinTour = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinTour>>, TError,JoinTourMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof joinTour>>,
        TError,
        JoinTourMutationVariables,
        TContext
      > => {
      return useMutation(getJoinTourMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Tour
 */
export const tour = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Tour>(
      {url: `/tours/${slug}`, method: 'GET', signal
    },
      );
    }




export const getTourQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'tours',slug
    ] as const;
    }


export const getTourQueryOptions = <TData = Awaited<ReturnType<typeof tour>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tour>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTourQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tour>>> = ({ signal }) => tour(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tour>>, TError, TData>
}

export type TourQueryResult = NonNullable<Awaited<ReturnType<typeof tour>>>
export type TourQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Tour
 */

export function useTour<TData = Awaited<ReturnType<typeof tour>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tour>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTourQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Tour
 */
export const updateTour = (
    slug: MaybeRefOrGetter<string>,
    tourUpdateInput: MaybeRefOrGetter<TourUpdateInput>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
tourUpdateInput = toValue(tourUpdateInput);

      return axiosClient<Tour>(
      {url: `/tours/${slug}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tourUpdateInput, signal
    },
      );
    }




export const getUpdateTourMutationKey = () => ['updateTour'] as const;

export const getUpdateTourMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTour>>, TError,UpdateTourMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTour>>, TError,UpdateTourMutationVariables, TContext> => {

const mutationKey = getUpdateTourMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTour>>, UpdateTourMutationVariables> = (props) => {
          const {slug,data} = props ?? {};

          return  updateTour(slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTourMutationResult = NonNullable<Awaited<ReturnType<typeof updateTour>>>
    export type UpdateTourMutationBody = TourUpdateInput
    export type UpdateTourMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateTourMutationVariables = {slug: string;data: TourUpdateInput}

    /**
 * @summary Update Tour
 */
export const useUpdateTour = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTour>>, TError,UpdateTourMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateTour>>,
        TError,
        UpdateTourMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTourMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Tour
 */
export const destroyTour = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Tour>(
      {url: `/tours/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyTourMutationKey = () => ['destroyTour'] as const;

export const getDestroyTourMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyTour>>, TError,DestroyTourMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyTour>>, TError,DestroyTourMutationVariables, TContext> => {

const mutationKey = getDestroyTourMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyTour>>, DestroyTourMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  destroyTour(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyTourMutationResult = NonNullable<Awaited<ReturnType<typeof destroyTour>>>

    export type DestroyTourMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyTourMutationVariables = {slug: string}

    /**
 * @summary Delete Tour
 */
export const useDestroyTour = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyTour>>, TError,DestroyTourMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyTour>>,
        TError,
        DestroyTourMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyTourMutationOptions(options), queryClient);
    }
    /**
 * @summary Settle Tour
 */
export const settleTour = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Tour>(
      {url: `/tours/${slug}/settle`, method: 'PUT', signal
    },
      );
    }




export const getSettleTourMutationKey = () => ['settleTour'] as const;

export const getSettleTourMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settleTour>>, TError,SettleTourMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof settleTour>>, TError,SettleTourMutationVariables, TContext> => {

const mutationKey = getSettleTourMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settleTour>>, SettleTourMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  settleTour(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettleTourMutationResult = NonNullable<Awaited<ReturnType<typeof settleTour>>>

    export type SettleTourMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SettleTourMutationVariables = {slug: string}

    /**
 * @summary Settle Tour
 */
export const useSettleTour = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settleTour>>, TError,SettleTourMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settleTour>>,
        TError,
        SettleTourMutationVariables,
        TContext
      > => {
      return useMutation(getSettleTourMutationOptions(options), queryClient);
    }
    /**
 * @summary Ask To Join Tour
 */
export const createTourJoinRequest = (
    tourSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      tourSlug = toValue(tourSlug);

      return axiosClient<TourJoinRequest>(
      {url: `/tours/${tourSlug}/join-requests`, method: 'POST', signal
    },
      );
    }




export const getCreateTourJoinRequestMutationKey = () => ['createTourJoinRequest'] as const;

export const getCreateTourJoinRequestMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTourJoinRequest>>, TError,CreateTourJoinRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTourJoinRequest>>, TError,CreateTourJoinRequestMutationVariables, TContext> => {

const mutationKey = getCreateTourJoinRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTourJoinRequest>>, CreateTourJoinRequestMutationVariables> = (props) => {
          const {tourSlug} = props ?? {};

          return  createTourJoinRequest(tourSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTourJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createTourJoinRequest>>>

    export type CreateTourJoinRequestMutationError = ErrorType<ValidationError | StandardError>
    export type CreateTourJoinRequestMutationVariables = {tourSlug: string}

    /**
 * @summary Ask To Join Tour
 */
export const useCreateTourJoinRequest = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTourJoinRequest>>, TError,CreateTourJoinRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTourJoinRequest>>,
        TError,
        CreateTourJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTourJoinRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary List Tour Join Requests
 */
export const tourJoinRequests = (
    tourSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      tourSlug = toValue(tourSlug);

      return axiosClient<TourJoinRequestsList>(
      {url: `/tours/${tourSlug}/join-requests`, method: 'GET', signal
    },
      );
    }




export const getTourJoinRequestsQueryKey = (tourSlug: MaybeRefOrGetter<string>,) => {
    return [
    'tours',tourSlug,'join-requests'
    ] as const;
    }


export const getTourJoinRequestsQueryOptions = <TData = Awaited<ReturnType<typeof tourJoinRequests>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(tourSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tourJoinRequests>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTourJoinRequestsQueryKey(tourSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tourJoinRequests>>> = ({ signal }) => tourJoinRequests(tourSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(tourSlug) !== null && toValue(tourSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tourJoinRequests>>, TError, TData>
}

export type TourJoinRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof tourJoinRequests>>>
export type TourJoinRequestsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Tour Join Requests
 */

export function useTourJoinRequests<TData = Awaited<ReturnType<typeof tourJoinRequests>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 tourSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tourJoinRequests>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTourJoinRequestsQueryOptions(tourSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Withdraw Tour Join Request
 */
export const destroyTourJoinRequest = (
    tourSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      tourSlug = toValue(tourSlug);
id = toValue(id);

      return axiosClient<TourJoinRequest>(
      {url: `/tours/${tourSlug}/join-requests/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyTourJoinRequestMutationKey = () => ['destroyTourJoinRequest'] as const;

export const getDestroyTourJoinRequestMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyTourJoinRequest>>, TError,DestroyTourJoinRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyTourJoinRequest>>, TError,DestroyTourJoinRequestMutationVariables, TContext> => {

const mutationKey = getDestroyTourJoinRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyTourJoinRequest>>, DestroyTourJoinRequestMutationVariables> = (props) => {
          const {tourSlug,id} = props ?? {};

          return  destroyTourJoinRequest(tourSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyTourJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof destroyTourJoinRequest>>>

    export type DestroyTourJoinRequestMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyTourJoinRequestMutationVariables = {tourSlug: string;id: string}

    /**
 * @summary Withdraw Tour Join Request
 */
export const useDestroyTourJoinRequest = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyTourJoinRequest>>, TError,DestroyTourJoinRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyTourJoinRequest>>,
        TError,
        DestroyTourJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyTourJoinRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Approve Tour Join Request
 */
export const approveTourJoinRequest = (
    tourSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      tourSlug = toValue(tourSlug);
id = toValue(id);

      return axiosClient<TourJoinRequest>(
      {url: `/tours/${tourSlug}/join-requests/${id}/approve`, method: 'PUT', signal
    },
      );
    }




export const getApproveTourJoinRequestMutationKey = () => ['approveTourJoinRequest'] as const;

export const getApproveTourJoinRequestMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTourJoinRequest>>, TError,ApproveTourJoinRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveTourJoinRequest>>, TError,ApproveTourJoinRequestMutationVariables, TContext> => {

const mutationKey = getApproveTourJoinRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveTourJoinRequest>>, ApproveTourJoinRequestMutationVariables> = (props) => {
          const {tourSlug,id} = props ?? {};

          return  approveTourJoinRequest(tourSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveTourJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveTourJoinRequest>>>

    export type ApproveTourJoinRequestMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ApproveTourJoinRequestMutationVariables = {tourSlug: string;id: string}

    /**
 * @summary Approve Tour Join Request
 */
export const useApproveTourJoinRequest = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTourJoinRequest>>, TError,ApproveTourJoinRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof approveTourJoinRequest>>,
        TError,
        ApproveTourJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getApproveTourJoinRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline Tour Join Request
 */
export const declineTourJoinRequest = (
    tourSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      tourSlug = toValue(tourSlug);
id = toValue(id);

      return axiosClient<TourJoinRequest>(
      {url: `/tours/${tourSlug}/join-requests/${id}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineTourJoinRequestMutationKey = () => ['declineTourJoinRequest'] as const;

export const getDeclineTourJoinRequestMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineTourJoinRequest>>, TError,DeclineTourJoinRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineTourJoinRequest>>, TError,DeclineTourJoinRequestMutationVariables, TContext> => {

const mutationKey = getDeclineTourJoinRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineTourJoinRequest>>, DeclineTourJoinRequestMutationVariables> = (props) => {
          const {tourSlug,id} = props ?? {};

          return  declineTourJoinRequest(tourSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineTourJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof declineTourJoinRequest>>>

    export type DeclineTourJoinRequestMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DeclineTourJoinRequestMutationVariables = {tourSlug: string;id: string}

    /**
 * @summary Decline Tour Join Request
 */
export const useDeclineTourJoinRequest = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineTourJoinRequest>>, TError,DeclineTourJoinRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineTourJoinRequest>>,
        TError,
        DeclineTourJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineTourJoinRequestMutationOptions(options), queryClient);
    }
